module.exports = __webpack_public_path__ + "img/ss_pink-04.3b2ff5c9.jpg";